import React, { Component } from 'react';
import Http from '../../../Http';
import toast from 'react-hot-toast';

export default class Cobro extends Component {
  state = {
    loading: true,
    saving: false,
    cobro_iva: '',
    cobro_retencion: '',
    cobro_seguro: '',
    cobro_factor_carga: '',
    cobro_factor_descarga: '',
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true });
    try {
      const res = await Http.get('prop/user');
      if (!res.error && res.data) {
        const d = res.data;
        this.setState({
          cobro_iva: d.cobro_iva ?? '',
          cobro_retencion: d.cobro_retencion ?? '',
          cobro_seguro: d.cobro_seguro ?? '',
          cobro_factor_carga: d.cobro_factor_carga ?? '',
          cobro_factor_descarga: d.cobro_factor_descarga ?? '',
        });
      } else {
        toast.error('No se pudo cargar la configuración de cobros');
      }
    } catch (error) {
      console.error('[Cobro@loadData]', error);
      toast.error('Error al consultar configuración de cobros');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const {
      cobro_iva,
      cobro_retencion,
      cobro_seguro,
      cobro_factor_carga,
      cobro_factor_descarga,
    } = this.state;

    this.setState({ saving: true });
    try {
      const payload = {
        cobro_iva: cobro_iva === '' ? null : Number(cobro_iva),
        cobro_retencion: cobro_retencion === '' ? null : Number(cobro_retencion),
        cobro_seguro: cobro_seguro === '' ? null : Number(cobro_seguro),
        cobro_factor_carga: cobro_factor_carga === '' ? null : Number(cobro_factor_carga),
        cobro_factor_descarga: cobro_factor_descarga === '' ? null : Number(cobro_factor_descarga),
      };

      const res = await Http.post('prop/user/save', payload);
      if (!res.error) {
        toast.success('¡Parámetros de cobro guardados con éxito!');
      } else {
        toast.error(res.errMsg || 'Error al guardar parámetros de cobro');
      }
    } catch (error) {
      console.error('[Cobro@handleSubmit]', error);
      toast.error('Error de conexión al guardar cobros');
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const {
      loading,
      saving,
      cobro_iva,
      cobro_retencion,
      cobro_seguro,
      cobro_factor_carga,
      cobro_factor_descarga,
    } = this.state;

    if (loading) {
      return (
        <div className="w-full flex flex-col items-center justify-center p-16">
          <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-gray-500 text-sm font-medium">Cargando parámetros de cobro...</p>
        </div>
      );
    }

    return (
      <form onSubmit={this.handleSubmit} className="space-y-8">
        {/* Section 1: Impuestos y Porcentajes */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-5">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Impuestos y Retenciones</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Valores predeterminados aplicados a la facturación de servicios y cálculo de importes.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-blue-50 text-blue-700 border border-blue-200 rounded-md">
              Fiscal y Comercial
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* IVA */}
            <div className="bg-gray-50/50 rounded-xl p-4 border border-gray-200/80">
              <label htmlFor="cobro_iva" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                % I.V.A. Aplicado
              </label>
              <div className="relative rounded-lg shadow-2xs">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  id="cobro_iva"
                  name="cobro_iva"
                  value={cobro_iva}
                  onChange={this.handleChange}
                  placeholder="16.00"
                  className="w-full pl-4 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
                <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400 font-bold text-sm">
                  %
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-1.5">
                Tasa estándar de IVA en facturación (ej. 16% o 8% en franja fronteriza).
              </p>
            </div>

            {/* Retención */}
            <div className="bg-gray-50/50 rounded-xl p-4 border border-gray-200/80">
              <label htmlFor="cobro_retencion" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                % Retención
              </label>
              <div className="relative rounded-lg shadow-2xs">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  id="cobro_retencion"
                  name="cobro_retencion"
                  value={cobro_retencion}
                  onChange={this.handleChange}
                  placeholder="4.00"
                  className="w-full pl-4 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
                <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400 font-bold text-sm">
                  %
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-1.5">
                Porcentaje de retención de transporte terrestre (comúnmente 4%).
              </p>
            </div>

            {/* Seguro */}
            <div className="bg-gray-50/50 rounded-xl p-4 border border-gray-200/80">
              <label htmlFor="cobro_seguro" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                % de Seguro
              </label>
              <div className="relative rounded-lg shadow-2xs">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  id="cobro_seguro"
                  name="cobro_seguro"
                  value={cobro_seguro}
                  onChange={this.handleChange}
                  placeholder="1.50"
                  className="w-full pl-4 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
                <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400 font-bold text-sm">
                  %
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-1.5">
                Porcentaje calculado sobre el valor declarado de las mercancías transportadas.
              </p>
            </div>
          </div>
        </div>

        {/* Section 2: Factores de Maniobras */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-5">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Factores Operativos de Maniobras</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Multiplicadores utilizados en el cálculo automático de maniobras de carga y descarga.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-gray-100 text-gray-600 rounded-md">
              Operaciones
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Factor Carga */}
            <div className="bg-gray-50/50 rounded-xl p-4 border border-gray-200/80">
              <label htmlFor="cobro_factor_carga" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                Factor Maniobra de Carga
              </label>
              <div className="relative rounded-lg shadow-2xs">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  id="cobro_factor_carga"
                  name="cobro_factor_carga"
                  value={cobro_factor_carga}
                  onChange={this.handleChange}
                  placeholder="1.00"
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
              </div>
              <p className="text-xs text-gray-400 mt-1.5">
                Factor multiplicador para maniobras de estiba y carga en origen.
              </p>
            </div>

            {/* Factor Descarga */}
            <div className="bg-gray-50/50 rounded-xl p-4 border border-gray-200/80">
              <label htmlFor="cobro_factor_descarga" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                Factor Maniobra de Descarga
              </label>
              <div className="relative rounded-lg shadow-2xs">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  id="cobro_factor_descarga"
                  name="cobro_factor_descarga"
                  value={cobro_factor_descarga}
                  onChange={this.handleChange}
                  placeholder="1.00"
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500"
                />
              </div>
              <p className="text-xs text-gray-400 mt-1.5">
                Factor multiplicador para maniobras de desestiba y descarga en destino.
              </p>
            </div>
          </div>
        </div>

        {/* Action */}
        <div className="flex items-center justify-end gap-3 pt-2">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-semibold text-white bg-orange-600 hover:bg-orange-700 active:bg-orange-800 shadow-sm transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Guardando cambios...</span>
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Guardar Parámetros de Cobro</span>
              </>
            )}
          </button>
        </div>
      </form>
    );
  }
}
